import { CirclePlus, ShoppingBag } from 'lucide-react';
import React, { type ReactNode } from 'react';
import LeftIcon from '@/assets/store/icon/left-icon.svg';
import Logo from '@/assets/store/icon/logo.svg';
import Plus from '@/assets/store/icon/plus-bar.svg';
import ShopICon from '@/assets/store/icon/shop-icon.svg';
import { registerCartIcon } from '@/domains/mobile-web/utils/flyToCart';
import { cn } from '@/lib/utils';

interface TopBarHeaderProps {
  icon?: ReactNode;
  type: 'back' | 'textBucket' | 'backAction';
  title?: string;
  totalProduct?: number;
  showLogo?: boolean;
  className?: string;
  onAction?: () => void;
  onBack?: () => void;
  onAdd?: () => void;
}

const TopBarHeader = ({
  showLogo = false,
  icon,
  type,
  title,
  className,
  totalProduct,
  onAction,
  onBack,
  onAdd,
}: TopBarHeaderProps) => {
  const headerMap: Record<TopBarHeaderProps['type'], ReactNode> = {
    back: (
      <div className={cn('w-full inline-flex py-3 items-center gap-3', className)}>
        <button
          onClick={onBack}
          type="button"
          className="inline-flex gap-2 items-center shrink-0 w-fit"
        >
          <img src={LeftIcon} alt={type} width={24} height={24} className="size-6" />
          <span className="title1bold text-black capitalize truncate ">{title}</span>
        </button>
      </div>
    ),

    backAction: (
      <div className={cn('w-full inline-flex justify-between py-3 items-center gap-3', className)}>
        <button onClick={onBack} type="button" className="inline-flex gap-2 items-center">
          <img src={LeftIcon} alt={type} width={24} height={24} className="size-6" />
          <span className="title1bold text-black capitalize">{title}</span>
        </button>
        <button onClick={onAdd} type="button" className="inline-flex gap-2 items-center">
          <img src={Plus} alt={type} className="size-5" />
          <span className="title2medium text-text-blue-100 capitalize">Tambah</span>
        </button>
      </div>
    ),

    textBucket: (
      <div className={cn('w-full inline-flex py-3 items-center justify-between', className)}>
        <div className="inline-flex items-center gap-2">
          {onBack ? (
            <button onClick={onBack} type="button" className="inline-flex items-center gap-2">
              <img src={LeftIcon} alt="back" width={24} height={24} className="size-6" />

              {title && <span className="title1bold text-black capitalize">{title}</span>}
            </button>
          ) : (
            <>
              {title && <span className="title1bold text-black">{title}</span>}

              {showLogo && (
                <img
                  src={Logo}
                  alt="rumah kebijaksanaan"
                  className="w-auto h-auto"
                  loading="eager"
                />
              )}
            </>
          )}
        </div>

        <button ref={registerCartIcon} onClick={onAction} type="button" className="relative flex">
          <img
            src={ShopICon}
            alt="shop"
            className="w-auto h-auto"
            loading="eager"
            width="160"
            height="40"
          />

          {totalProduct !== undefined && totalProduct > 0 && (
            // key re-mounts the badge on every count change so the pop animation replays
            <span
              key={totalProduct}
              className="caption absolute -right-[7px] -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-text-danger-500 text-white animate-badge-pop motion-reduce:animate-none"
            >
              {totalProduct}
            </span>
          )}
        </button>
      </div>
    ),
  };

  return headerMap[type];
};

export default TopBarHeader;
